<div [hidden]="hideLoader" id="custom_spinner" class="sk-wave" [class.colored]="!backgroundColor">
  <div class="sk-rect sk-rect1" [style.background-color]="backgroundColor"></div>
  <div class="sk-rect sk-rect2" [style.background-color]="backgroundColor"></div>
  <div class="sk-rect sk-rect3" [style.background-color]="backgroundColor"></div>
  <div class="sk-rect sk-rect4" [style.background-color]="backgroundColor"></div>
  <div class="sk-rect sk-rect5" [style.background-color]="backgroundColor"></div>
</div>

<div class="table-responsive" style="width: 100%; overflow-x: auto; max-height: 68vh;">
  <table [id]="tableId" [ngClass]="tableClass">
    <thead ng2-st-thead *ngIf="!isHideHeader || !isHideSubHeader" [grid]="grid" [isAllSelected]="isAllSelected"
      [source]="source" [createConfirm]="createConfirm" (create)="create.emit($event)"
      (selectAllRows)="onSelectAllRows($event)" (sort)="sort($event)" (filter)="filter($event)">
    </thead>
    <tbody ng2-st-tbody [grid]="grid" [source]="source" [deleteConfirm]="deleteConfirm" [editConfirm]="editConfirm"
      [rowClassFunction]="rowClassFunction" (edit)="edit.emit($event)" (delete)="delete.emit($event)"
      (custom)="custom.emit($event)" (userSelectRow)="onUserSelectRow($event)" (editRowSelect)="editRowSelect($event)"
      (multipleSelectRow)="multipleSelectRow($event)" (rowHover)="onRowHover($event)">
    </tbody>
  </table>
</div>
<div class="d-flex align-items-center" style="padding-top: 1rem !important;">
  <ng2-smart-table-pager class="float-left pr-2" *ngIf="isPagerDisplay" [source]="source"
    (changePage)="changePage($event)">
  </ng2-smart-table-pager>
  <div class="form-inline" *ngIf="shouldShow()">
    <p class="m-0 font-small font-color-gray font-weight-semibold">
      <select class="custom-select" [ngModel]="selectedPages" (ngModelChange)="onSelectPages($event)">
        <option *ngFor="let pages of selectOptions" [value]="pages">{{pages + ' per page'}}</option>
      </select>
      Total {{pagerTitle}}: {{totalRecordsDisplay}}
    </p>
  </div>

</div>

<!-- <spinner [spinner]="spinkit.skWave" id="custom_spinner"></spinner> -->

<style>
  .sk-wave {
    position: fixed;
    top: 50%;
    margin: auto;
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
    left: 44%;
    top: 47%;

  }

  .sk-wave .sk-rect {
    height: 100%;
    width: 6px;
    display: inline-block;
    -webkit-animation: sk-waveStretchDelay 1.2s infinite ease-in-out;
    animation: sk-waveStretchDelay 1.2s infinite ease-in-out
  }

  .sk-wave .sk-rect1 {
    -webkit-animation-delay: -1.2s;
    animation-delay: -1.2s
  }

  .sk-wave .sk-rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s
  }

  .sk-wave .sk-rect3 {
    -webkit-animation-delay: -1s;
    animation-delay: -1s
  }

  .sk-wave .sk-rect5 {
    -webkit-animation-delay: -.8s;
    animation-delay: -.8s
  }

  .sk-wave .sk-rect4 {
    -webkit-animation-delay: -.9s;
    animation-delay: -.9s
  }

  @-webkit-keyframes sk-waveStretchDelay {

    0%,
    100%,
    40% {
      -webkit-transform: scaleY(.4);
      transform: scaleY(.4)
    }

    20% {
      -webkit-transform: scaleY(1);
      transform: scaleY(1)
    }
  }

  @keyframes sk-waveStretchDelay {

    0%,
    100%,
    40% {
      -webkit-transform: scaleY(.4);
      transform: scaleY(.4)
    }

    20% {
      -webkit-transform: scaleY(1);
      transform: scaleY(1)
    }
  }
</style>



<!-- <div class="lds-css ng-scope" id="custom_spinner">
  <div class="lds-spinner" style="position: fixed; top: 50%; left: 43%; transform: translate(-50%, -50%);">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <style type="text/css">
    @keyframes lds-spinner {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }

    @-webkit-keyframes lds-spinner {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }

    .lds-spinner {
      position: relative;
    }

    .lds-spinner div {
      left: 94px;
      top: 48px;
      position: absolute;
      -webkit-animation: lds-spinner linear 1s infinite;
      animation: lds-spinner linear 1s infinite;
      background: #a00d1e;
      width: 12px;
      height: 24px;
      border-radius: 40%;
      -webkit-transform-origin: 6px 52px;
      transform-origin: 6px 52px;
    }

    .lds-spinner div:nth-child(1) {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-animation-delay: -0.928571428571429s;
      animation-delay: -0.928571428571429s;
    }

    .lds-spinner div:nth-child(2) {
      -webkit-transform: rotate(25.714285714285715deg);
      transform: rotate(25.714285714285715deg);
      -webkit-animation-delay: -0.857142857142857s;
      animation-delay: -0.857142857142857s;
    }

    .lds-spinner div:nth-child(3) {
      -webkit-transform: rotate(51.42857142857143deg);
      transform: rotate(51.42857142857143deg);
      -webkit-animation-delay: -0.785714285714286s;
      animation-delay: -0.785714285714286s;
    }

    .lds-spinner div:nth-child(4) {
      -webkit-transform: rotate(77.14285714285714deg);
      transform: rotate(77.14285714285714deg);
      -webkit-animation-delay: -0.714285714285714s;
      animation-delay: -0.714285714285714s;
    }

    .lds-spinner div:nth-child(5) {
      -webkit-transform: rotate(102.85714285714286deg);
      transform: rotate(102.85714285714286deg);
      -webkit-animation-delay: -0.642857142857143s;
      animation-delay: -0.642857142857143s;
    }

    .lds-spinner div:nth-child(6) {
      -webkit-transform: rotate(128.57142857142858deg);
      transform: rotate(128.57142857142858deg);
      -webkit-animation-delay: -0.571428571428571s;
      animation-delay: -0.571428571428571s;
    }

    .lds-spinner div:nth-child(7) {
      -webkit-transform: rotate(154.28571428571428deg);
      transform: rotate(154.28571428571428deg);
      -webkit-animation-delay: -0.5s;
      animation-delay: -0.5s;
    }

    .lds-spinner div:nth-child(8) {
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
      -webkit-animation-delay: -0.428571428571429s;
      animation-delay: -0.428571428571429s;
    }

    .lds-spinner div:nth-child(9) {
      -webkit-transform: rotate(205.71428571428572deg);
      transform: rotate(205.71428571428572deg);
      -webkit-animation-delay: -0.357142857142857s;
      animation-delay: -0.357142857142857s;
    }

    .lds-spinner div:nth-child(10) {
      -webkit-transform: rotate(231.42857142857142deg);
      transform: rotate(231.42857142857142deg);
      -webkit-animation-delay: -0.285714285714286s;
      animation-delay: -0.285714285714286s;
    }

    .lds-spinner div:nth-child(11) {
      -webkit-transform: rotate(257.14285714285717deg);
      transform: rotate(257.14285714285717deg);
      -webkit-animation-delay: -0.214285714285714s;
      animation-delay: -0.214285714285714s;
    }

    .lds-spinner div:nth-child(12) {
      -webkit-transform: rotate(282.85714285714283deg);
      transform: rotate(282.85714285714283deg);
      -webkit-animation-delay: -0.142857142857143s;
      animation-delay: -0.142857142857143s;
    }

    .lds-spinner div:nth-child(13) {
      -webkit-transform: rotate(308.57142857142856deg);
      transform: rotate(308.57142857142856deg);
      -webkit-animation-delay: -0.071428571428571s;
      animation-delay: -0.071428571428571s;
    }

    .lds-spinner div:nth-child(14) {
      -webkit-transform: rotate(334.2857142857143deg);
      transform: rotate(334.2857142857143deg);
      -webkit-animation-delay: 0s;
      animation-delay: 0s;
    }

    .lds-spinner {
      width: 200px !important;
      height: 200px !important;
      -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
      transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    }
  </style>
</div> -->